import { VehicleUnitSizeModal } from 'components/unit/VehicleUnitSizeModal';
import { VehicleAccommodationsModal } from 'components/unit/VehicleAccommodationsModal';

const sortOptions = [{
	label: 'Distance',
	name: 'sort',
	value: 'distance',
	default: true
}, {
	label: 'Price',
	name: 'sort',
	value: 'price'
}, {
	label: 'Rating',
	name: 'sort',
	value: 'rating'
}];

const distanceOptions = [{
	label: '5 Miles',
	name: 'distance',
	value: '5'
}, {
	label: '10 Miles',
	name: 'distance',
	value: '10'
}, {
	label: '20 Miles',
	name: 'distance',
	value: '20'
}, {
	label: '30 Miles',
	name: 'distance',
	value: '30'
}];

const defaultUnitFilters = {
	storage: {
		amenities: {
			label: 'Amenities',
			default: true,
			type: 'checkbox',
			multiple: true,
			options: [{
				label: 'Express Check-Ins Offered',
				name: 'amenities',
				value: 'hasOnlineMoveins'
			}, {
				label: 'Alarm',
				name: 'amenities',
				value: 'alarm'
			}, {
				label: 'Climate Controlled',
				name: 'amenities',
				value: 'climateControlled'
			}, {
				label: 'Drive Up Access',
				name: 'amenities',
				value: 'driveUp'
			}, {
				label: '1st Floor',
				name: 'amenities',
				value: 'firstFloor'
			}, {
				label: '24 Hour Access',
				name: 'amenities',
				value: 'twentyFourHourAccess'
			}, {
				label: 'Free Truck Rental',
				name: 'amenities',
				value: 'freeTruckRental'
			}, {
				label: 'Open Now',
				name: 'amenities',
				value: 'openNow'
			}]
		},
		sort: {
			label: 'Sort By',
			type: 'radio',
			options: sortOptions
		},
		size: {
			label: 'Unit Size',
			type: 'checkbox',
			options: [{
				label: "5' x 5'",
				name: 'sqft',
				value: '0-25'
			}, {
				label: "5' x 10'",
				name: 'sqft',
				value: '26-60'
			}, {
				label: "5' x 15'",
				name: 'sqft',
				value: '61-75'
			}, {
				label: "10' x 10'",
				name: 'sqft',
				value: '76-100'
			}, {
				label: "10' x 15'",
				name: 'sqft',
				value: '101-150'
			}, {
				label: "10' x 20'",
				name: 'sqft',
				value: '151-200'
			}, {
				label: "10' x 25'",
				name: 'sqft',
				value: '201-250'
			}, {
				label: "10' x 30'",
				name: 'sqft',
				value: '251-300'
			}]
		},
		distance: {
			label: 'Distance',
			type: 'checkbox',
			options: distanceOptions
		}
	},
	vehicle: {
		length: {
			label: 'Vehicle Unit Size',
			default: true,
			modal: {
				title: 'View our vehicle unit size guide',
				component: VehicleUnitSizeModal
			},
			options: [{
				label: "15' Long",
				name: 'length',
				value: '15-19.99'
			}, {
				label: "20' Long",
				name: 'length',
				value: '20-24.99'
			}, {
				label: "25' Long",
				name: 'length',
				value: '25-29.99'
			}, {
				label: "30' Long",
				name: 'length',
				value: '30-34.99'
			}, {
				label: "35' Long",
				name: 'length',
				value: '35-39.99'
			}, {
				label: "40' Long",
				name: 'length',
				value: '40-49.99'
			}, {
				label: "50' Long",
				name: 'length',
				value: '50-999'
			}]
		},
		vehicleAccommodation: {
			label: 'Vehicle Unit Accommodations',
			modal: {
				title: 'View our vehicle accommodations guide',
				component: VehicleAccommodationsModal
			},
			options: [{
				label: 'Outdoor Uncovered Unit',
				name: 'vehicleAccommodation',
				value: 'outdoor-uncovered'
			}, {
				label: 'Outdoor Covered Unit',
				name: 'vehicleAccommodation',
				value: 'outdoor-covered'
			}, {
				label: 'Indoor Unit',
				name: 'vehicleAccommodation',
				value: 'indoor'
			}, {
				label: 'Enclosed Unit',
				name: 'vehicleAccommodation',
				value: 'enclosed'
			}]
		},
		storageRequirements: {
			label: 'Vehicle Storage Requirements',
			options: [{
				label: 'Title not required',
				name: 'vehicleTitleNotRequired',
				value: 'true'
			}, {
				label: 'Registration not required',
				name: 'vehicleRegistrationNotRequired',
				value: 'true'
			}, {
				label: 'Insurance not required',
				name: 'vehicleInsuranceNotRequired',
				value: 'true'
			}, {
				label: "Doesn't have to be drivable",
				name: 'vehicleDrivableNotRequired',
				value: 'true'
			}]
		},
		amenities: {
			label: 'Amenities',
			multiple: true,
			options: [{
				label: '24-hour access',
				name: 'amenities',
				value: 'twentyFourHourAccess'
			}, {
				label: 'Electronic gate access',
				name: 'amenities',
				value: 'eGateAccess',
				facetName: 'egateAccess'
			}, {
				label: 'Drive-up access',
				name: 'amenities',
				value: 'driveUp'
			}, {
				label: 'Self-service kiosk',
				name: 'amenities',
				value: 'kiosk'
			}, {
				label: 'Alarm in unit',
				name: 'amenities',
				value: 'alarm'
			}, {
				label: 'Fenced and lit',
				name: 'amenities',
				value: 'fencedAndLit',
				facetName: 'fencedLighted'
			}, {
				label: 'Surveillance cameras',
				name: 'amenities',
				value: 'cameras',
				facetName: 'surveillance'
			}, {
				label: 'Is open',
				name: 'amenities',
				value: 'getOpenNow'
			}, {
				label: 'Has special',
				name: 'amenities',
				value: 'hasSpecial'
			}, {
				label: 'Pull-through access',
				name: 'amenities',
				value: 'pullthrough',
				facetName: 'truckAccess'
			}]
		},

		sort: {
			label: 'Sort By',
			options: sortOptions
		},
		distance: {
			label: 'Distance',
			options: distanceOptions
		}
	},
	searchTypes: {
		label: 'Search Types',
		multiple: true,
		options: [{
			label: 'Self-Storage',
			name: 'amenities',
			value: null
		}, {
			label: 'Vehicle Storage',
			name: 'amenities',
			value: 'vehicle'
		}, 	{
			label: 'Alarm Storage',
			name: 'amenities',
			value: 'alarm'
		}, {
			label: 'Climate Controlled Storage',
			name: 'amenities',
			value: 'climateControlled'
		}, {
			label: 'Drive Up Access Storage',
			name: 'amenities',
			value: 'driveUp'
		}, {
			label: '1st Floor Storage',
			name: 'amenities',
			value: 'firstFloor'
		}, {
			label: '24 Hour Access Storage',
			name: 'amenities',
			value: 'twentyFourHourAccess'
		}, {
			label: 'Free Truck Rental Storage',
			name: 'amenities',
			value: 'freeTruckRental'
		}, {
			label: 'Open Now',
			name: 'amenities',
			value: 'openNow'
		}]
	}
};

export default defaultUnitFilters;
